<style lang="less">
    .page_con.artical{
        height:100vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
    .art_content{
        width:100%;
        overflow: hidden;
        position: relative;
        flex:1;
        // padding:.6rem 0 0;
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        // justify-content: center;
        .pd{
            width:100%;
            flex:1;
            margin-top:.6rem;
            padding: 0 .2rem;
        }
        .art_bottom{
            width:100%;
            height:auto;
            position: relative;
            img.art_bottom_bg{
                width:100%;
                height:auto;
                display: block;
            }
            img.art_bottom_flowers{
                width:1.2rem;
                height:auto;
                display: block;
                position: absolute;
                left: .3rem;
                bottom:0;
                z-index: 11;
            }
            img.art_bottom_sunflowers{
                width:1.8rem;
                height:auto;
                display: block;
                position: absolute;
                right: 0rem;
                bottom:.1rem;
                z-index: 11;
            }
        }
    }
    .art_title{
        width:100%;
        height:1.3rem;
        font-size: .46rem;
        text-shadow:0px 2px 2px rgba(0, 0, 0, 0.5);
        color:#fff;
        position: absolute;
        left:0;
        top:0;
        z-index: 11;
        display: flex;
        align-items: center;
        justify-content: center;
        background:url("../assets/images/title-pc.png") no-repeat;
        background-position: center;
        background-size: auto 100%;
        span{
            padding-bottom: .2rem;
        }
    }
    .artical .art_text_con{
        width:100%;
        height:auto;
        background: #78D3FF;
        border:2px solid #1D2088;
        box-shadow:0px .08rem .02rem 0px rgba(0, 0, 0, 0.3);
        border-radius: .1rem;
        padding:.9rem .2rem .2rem;
        >img{
            width:100%;
            height:auto;
            display: block;
        }
        .art_inner{
            width:100%;
            height:60vh;
            background:#FFFDE4;
            // border-radius: .15rem;
            padding:.2rem .4rem;
            display: flex;
            flex-direction: column;
            >div{
                width:100%;
                height:100%;
                overflow-x: hidden;
                overflow-y: auto;
                >img{
                    width:100%;
                    height:auto;
                    display: block;
                    margin-bottom: .4rem;
                }
            }
            .art-tips{
                width:100%;
                line-height: 1.5;
                font-size: .32rem;
                color:red;
                padding:0 .2rem;
            }
        }
        .art_btns{
            width:100%;
            padding:0 .2rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: .4rem;
            .btns_left{
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .art_btn{
                width:1.6rem;
                height:.8rem;
                margin-right:.2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: .32rem;
                color:#fff;
                background:url("../assets/images/button2language-phone.png") no-repeat;
                background-size: 100% 100%;
                >span{
                    margin-bottom: .1rem;
                }
            }
            .art_btn.active{
                background-image:url("../assets/images/button1language-phone.png");
            }
            .art_refresh{
                width:1rem;
                height:.8rem;
                img{
                    width:100%;
                    height:auto;
                    display: block;
                }
            }
        }
    }
    .art_video_con{
        width:100%;
        padding:0 .2rem;
        overflow: hidden;
        z-index: 0;
        video{
            width:100%;
            height:auto;
        }
    }
@media screen and (min-width: 769px){
    .page_con.artical{
        height:667px;
    }
    .art_content{
        flex:unset;
        height:calc(100% - 75px);
    }
    .art_content .pd{
        flex:unset;
        height:calc(100% - 96px);
        overflow: hidden;
    }
    .art_content .pd::-webkit-scrollbar {
        width: 0;
    }
    .artical .art_text_con{
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .artical .art_text_con .art_inner{
        height:calc(100% - 18px);
    }
    .artical .art_text_con .art_inner > div{
        height:100%;
        overflow-y: auto;
    }
    .artical .art_text_con .art_inner > div::-webkit-scrollbar {
        width: 0;
    }
}
</style>
<template>
    <div class="page_con artical">
        <div class="all_top">
            <div class="btnBack" @click="$router.go(-1)"></div>
            <div class="btnHome" @click="$router.push('/index')"></div>
        </div>
        <div class="art_content">
            <div class="pd">
                <div class="art_title">
                    <span>{{info.article_title}}</span>
                </div>
                <div class="art_text_con"><!-- 蓝底 padding -->
                    <img src="../assets/images/up-article-phone.png" alt="">
                    <div class="art_inner"><!-- 黄底 padding -->
                        <div v-if="info.article_video_yy">
                            <img :src="imgBaseUrl + info.article_top_image" alt="">
                            <div class="art_btns">
                                <div class="btns_left">
                                    <div @click="changeLang(1)" :class="['art_btn',lang===1?'active':'']">
                                        <span>廣東話</span>
                                    </div>
                                    <div @click="changeLang(2)" :class="['art_btn',lang===2?'active':'']">
                                        <span>普通話</span>
                                    </div>
                                </div>
                                <div class="art_refresh" @click="reload">
                                    <img src="../assets/images/again-pc.png" alt="">
                                </div>
                            </div>
                            <div class="art_video_con">
                                <video ref="video" autoplay>
                                    <source type="video/mp4" :src="imgBaseUrl + (videoSrc || info.article_video_yy)"></source>
                                </video>
                            </div>
                            <div class="art-tips" v-if="info.article_content">{{info.article_content}}</div>
                        </div>
                    </div>
                    <img src="../assets/images/down-article-phone.png" alt="">
                </div>
            </div>
            <div class="art_bottom">
                <img class="art_bottom_bg" src="../assets/images/bg3-phone.png" alt="">
                <img class="art_bottom_flowers" src="../assets/images/flowers.gif" alt="">
                <img class="art_bottom_sunflowers" src="../assets/images/sunflower.gif" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            info:{},
            lang:1,
            videoSrc:'',
        }
    },
    mounted(){
        let date = this.$route.query.pushdate;
        this.getData(date);
    },
    methods:{
        getData(date){
            let vm = this;
            vm.$http.get(this.baseUrl+'/Read/index.html?rest_key=1' + (date?'&pushdate='+date:'')).then(res=>{
                console.log(res)
                if(res.data.code == 1){
                    vm.info = res.data.data.info;
                    setTimeout(()=>{
                    vm.$refs.video.defaultMuted = false;
                    vm.reload();
                    },1000);
                }
            })
        },
        reload(){
            this.$refs.video.load();
        },
        changeLang(n){
            if(n === this.lang){
                this.$refs.video.play();
            }else{
                this.lang = n;
                if(n===1){
                    this.videoSrc = this.info['article_video_yy'];
                }else{
                    this.videoSrc = this.info['article_video_gy'];
                }
                this.$refs.video.load();
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/artical.vue